module.exports = __webpack_public_path__ + "static/media/contact.a9bc0d7a.svg";